module.exports = require("./yue-Hant.js");